export default class Validation{
    params={
        isFromValid:true,
        isToValid:true,
        isDeparutreDateValid:true,
        isArrivalDate:true,
    }
}